"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EventSender_1 = require("../reporters/EventSender");
const userAgent = () => {
    return {
        name: 'context_user_agent',
        data: { user_agent: navigator.userAgent },
    };
};
function createUniversalReporter(config = {}) {
    const context = config.context ? [userAgent, ...config.context] : [userAgent];
    return EventSender_1.EventSenderReporter.create(Object.assign(Object.assign({ environment: 'browser' }, config), { context }));
}
exports.createUniversalReporter = createUniversalReporter;
//# sourceMappingURL=createUniversalReporter.browser.js.map